export enum ViewType {
	Desktop = 1,
	Mobile = 3,
	Auto = 4
}